export const getInitialConfigForProgressBar = (config, options) => {
  return { config: config, options: options };
};
